import * as React from "react";
import GoldLink from "src/presentation/common/atom/btn/gold_link";
import styled from "styled-components";
import { Company } from "../../../../../domain/model/company";
import AvatarLarge from "../../../../common/atom/avatar/avatar_large";
import HeadlineMiddle from "../../../../common/atom/text/headline_middle";
import ProfileRightBtnWrapper from "../../../../common/atom/wrapper/profile_right_btn_wrapper";
import TableCompanyInfo from "../../../../common/template/table/table_company_info";

interface IProps {
  company: Company | null;
}

export const ClientMypageMainCompany: React.FC<IProps> = (props) => {
  const { company } = props;

  if (!company) {
    return <div />;
  }

  let res: JSX.Element;

  // 画像が無いとき
  // ServingURLは生成されない
  // デフォルト画像をBackendで付与して返答される
  const logoURL: string = company.getLogoURL();
  const companyName: string = company.name;

  // 通常ページ

  res = (
    <React.Fragment>
      <CompanyProfileWrapper>
        <CompanyProfileInner>
          <AvatarLarge src={logoURL} />
        </CompanyProfileInner>
        <CompanyProfileInner>
          <HeadlineMiddle>{companyName}</HeadlineMiddle>
        </CompanyProfileInner>
      </CompanyProfileWrapper>

      <ProfileRightBtnWrapper>
        <EditLink to={"/client/mypage/company/_edit"}>編集する</EditLink>
      </ProfileRightBtnWrapper>

      <TableCompanyInfo company={company} />
    </React.Fragment>
  );

  return res;
};

export default ClientMypageMainCompany;

const CompanyProfileWrapper = styled.div`
  margin: 40px auto;
  text-align: center;
`;

const CompanyProfileInner = styled.div`
  margin: 10px 0;
`;

const EditLink = styled(GoldLink)`
  font-size: 12px;
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/mypage/info_company/client_mypage_main_company.tsx